import { createSelector } from 'reselect'
// import { List } from 'immutable'

const authSelector = state => state.get('auth')

export const getUserData = createSelector(
  authSelector,
  authImmutable => {
    const auth = authImmutable.toJS()
    return auth.auth
  }
)
export const getChangePasswordData = createSelector(
  authSelector,
  authImmutable => {
    const auth = authImmutable.toJS()
    return auth.authChangePassword
  }
)
export const getAuth = createSelector(
  authSelector,
  authImmutable => {
    const auth = authImmutable.toJS()
    return auth.authAuth
  }
)
export const getAuthUser = createSelector(
  getAuth,
  authAuth => authAuth.user || {}
)

export const getIsSystemAdmin = createSelector(
  getAuth,
  getAuthUser,
  user => user.is_system_admin || false
)

export const redirectAuth = createSelector(
  authSelector,
  authImmutable => {
    const auth = authImmutable.toJS()
    return ({
      redirect: (auth.auth.redirect
      || auth.authChangePassword.redirect
      || auth.authAuth.redirect),
      isAuthenticated: (auth.auth.isAuthenticated
      || auth.authChangePassword.isAuthenticated
      || auth.authAuth.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/auth/auth-selector.js